const cards = {
    data() {
        return {
            
        };
    },
    methods: {
        
    },
    created() {
        console.log("cards");
    },
};

// Global cart object
const CARDS = {
    vue: null,
    loaded: false,
    load() {
        if (this.loaded) {
            return;
        }
        if (document.getElementById("cards") !== undefined) {
            this.loaded = true;
            this.vue = Vue.createApp(cards).mount("#cards");
            forms.load();
        }
    },
};
window.CARDS = CARDS;

window.addEventListener("DOMContentLoaded", () => {
    CARDS.load();
});
window.addEventListener("load", () => {
    CARDS.load();
});

if (document.readyState !== "loading") {
    LOGIN.load();
}
